import * as focusTrap from "focus-trap";

function isCKEditorPopup(node) {
  return node.closest(".ck") != null;
}

class ElmModal extends HTMLElement {
  connectedCallback() {
    this.previousActiveElement = document.activeElement;

    this.trap = focusTrap.createFocusTrap(this, {
      allowOutsideClick: (e) => isCKEditorPopup(e.target),
      returnFocusOnDeactivate: false,
    });

    this.trap.activate();

    this.handleGlobalFocus = this.handleGlobalFocus.bind(this);
    document.body.addEventListener("focusin", this.handleGlobalFocus, true);
  }

  disconnectedCallback() {
    this.trap.deactivate();
    this.trap = undefined;

    if (this.previousActiveElement) {
      let focusTarget = this.previousActiveElement;

      // If focus was on a new-dropdown item, focus the trigger instead
      if (this.previousActiveElement.closest(".new-dropdown-menu__item")) {
        const dropdown = this.previousActiveElement.closest(".new-dropdown");
        const trigger = dropdown?.querySelector(".new-dropdown__trigger");
        if (trigger) {
          focusTarget = trigger;
        }
      }

      focusTarget.focus();
    }

    this.previousActiveElement = undefined;
    document.body.removeEventListener("focusin", this.handleGlobalFocus, true);
  }

  handleGlobalFocus(e) {
    if (isCKEditorPopup(e.target)) {
      if (this.trap?.active) {
        this.trap.deactivate();
      }
    } else if (this.trap && !this.trap.active) {
      this.trap.activate();
    }
  }
}

customElements.define("elm-modal", ElmModal);
